/**
 * ko-intro-gate.js
 * ------------------
 * Progressive enhancement: if this fails to load, the gate element
 * still exists but never hides.
 *
 * NOTE on autoplay ordering: playing audio before vs. after hiding the
 * gate does not meaningfully change browser autoplay permission — a
 * click handler's "user gesture" status holds for its whole synchronous
 * execution regardless of DOM changes made inside it. If audio isn't
 * playing, check (in order): 1) the Audio track URL setting is filled
 * in, 2) the uploaded file is genuinely an MP3, 3) the browser console
 * for an actual play() rejection error.
 */
(function () {
  "use strict";

  var SESSION_KEY = "ko_entered";
  var gate = document.getElementById("ko-intro-gate");
  var enterBtn = document.getElementById("ko-intro-gate__enter");
  var audio = document.getElementById("ko-ambient-audio");
  var audioToggle = document.getElementById("ko-audio-toggle");
  var gateVideo = document.getElementById("ko-intro-gate__video");

  if (!gate) return;

  function showAudioToggle() {
    if (audio && audioToggle) {
      audioToggle.hidden = false;
    }
  }

  function hideGate(animate) {
    if (!animate) {
      gate.style.transition = "none";
    }
    gate.classList.add("ko-intro-gate--hidden");
    if (gateVideo) {
      gateVideo.pause();
    }
  }

  function enter() {
    if (audio) {
      audio.play().catch(function (e) {
        console.warn("Ambient audio blocked by browser:", e);
      });
      showAudioToggle();
      if (audioToggle) {
        audioToggle.setAttribute("aria-pressed", "false");
      }
    } else {
      console.warn("No #ko-ambient-audio element found on the page — check that the Audio track URL setting is filled in on the Intro Gate section.");
    }

    try {
      sessionStorage.setItem(SESSION_KEY, "true");
    } catch (e) {
      // sessionStorage unavailable (private browsing edge cases) —
      // gate will simply show again on next page load, not a
      // functional failure, just a slightly repeated intro.
    }

    hideGate(true);
  }

  function toggleAudio() {
    if (!audio) return;
    if (audio.paused) {
      audio.play().catch(function () {});
      audioToggle.setAttribute("aria-pressed", "false");
    } else {
      audio.pause();
      audioToggle.setAttribute("aria-pressed", "true");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var alreadyEntered = false;
    try {
      alreadyEntered = sessionStorage.getItem(SESSION_KEY) === "true";
    } catch (e) {
      alreadyEntered = false;
    }

    if (alreadyEntered) {
      hideGate(false);
      if (audio) {
        audio.play().catch(function () {});
        showAudioToggle();
      }
    }

    if (enterBtn) {
      enterBtn.addEventListener("click", enter);
    }
    if (audioToggle) {
      audioToggle.addEventListener("click", toggleAudio);
    }
  });
})();